import { Avatar } from 'antd';
import styled from 'styled-components';

export const StyledAvatar = styled(Avatar)`
    background: ${({ $theme }) => $theme.colors.canvas};
    cursor: pointer;
`;
